import { LocaleHelper } from './LocaleHelper'
import { path } from '../lib/ramda'

const FormHelper = {
  isFormValid: (formFields: any, fields: any) => {
    const messages: any = {}
    for (let i = 0; i < fields.length; i++) {
      const currentField = fields[i]
      const {
        name: fieldName,
        validation: validationType,
        required,
      } = currentField
      const fieldKeys = fieldName.split('.')
      const fieldValue = path(fieldKeys, formFields)
      if (required && !fieldValue) {
        messages[fieldName] = LocaleHelper.getText(
          'GENERAL_REQUIRED_VALIDATION'
        )
      }
      if (fieldValue && validationType) {
        // @ts-ignore
        const result = FormHelper.validation[validationType](
          fieldValue,
          formFields
        )
        if (result.valid === false) {
          messages[fieldName] = result.message
        }
      }
    }

    if (Object.keys(messages).length > 0) {
      return { valid: false, messages }
    }
    return { valid: true }
  },

  validation: {
    password: (text: string) => {
      if (text.length < 8) {
        return {
          valid: false,
          message: LocaleHelper.getText('PROFILE_PASSWORD_POLICY'),
        }
      }
      return { valid: true }
    },

    confirmPassword: (confirmedPassword: string, { password }: any) => {
      if (confirmedPassword !== password) {
        return {
          valid: false,
          message: LocaleHelper.getText('PROFILE_REPEAT_PASSWORD_VALIDATION'),
        }
      }
      return { valid: true }
    },

    verificationCode: (verificationCode: string) => {
      const testCode = verificationCode.trim()
      if (!/[0-9]{6}/.test(testCode)) {
        return {
          valid: false,
          message: LocaleHelper.getText('VERIFICATION_CODE_VALIDATION'),
        }
      }
      return { valid: true }
    },

    coordinates: (coords: any) => {
      if (coords && coords.length === 2) {
        if (!isNaN(coords[0]) && !isNaN(coords[1])) {
          return { valid: true }
        }
      }
      return {
        valid: false,
        message: LocaleHelper.getText('COORDINATE_VALIDATION'),
      }
    },

    email: (email: string) => {
      if (
        !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
          email
        )
      ) {
        return {
          valid: false,
          message: LocaleHelper.getText('GENERAL_EMAIL_VALIDATION'),
        }
      }
      return { valid: true }
    },

    phone: (phone: string) => {
      if (!/[0-9\s]+/.test(phone)) {
        return {
          valid: false,
          message: LocaleHelper.getText('GENERAL_PHONE_VALIDATION'),
        }
      }
      return { valid: true }
    },
  },
}

export { FormHelper }
